import { render } from "./MenuBlank.vue?vue&type=template&id=2c27479d&scoped=true"
import script from "./MenuBlank.vue?vue&type=script&lang=js"
export * from "./MenuBlank.vue?vue&type=script&lang=js"

import "./MenuBlank.vue?vue&type=style&index=0&id=2c27479d&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c27479d"]])

export default __exports__